/* Diffuser + 3 oils set picker. See snippets/ml-oil-set.liquid. */
if (!customElements.get('ml-oil-set')) {
  class MlOilSet extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-ml-form]');
      this.solo = this.querySelector('[data-ml-solo]');
      if (this.solo) this.solo.addEventListener('click', () => this.addSolo(this.solo));

      const data = this.querySelector('[data-ml-oils]');
      if (!data) return;
      this.oils = {};
      JSON.parse(data.textContent).forEach((o) => { this.oils[o.id] = o; });

      this.selects = Array.from(this.querySelectorAll('[data-ml-select]'));
      this.cta = this.querySelector('[data-ml-add]');
      this.sticky = this.querySelector('[data-ml-sticky]');
      this.stickyBtn = this.querySelector('[data-ml-sticky-btn]');

      this.selects.forEach((s) => s.addEventListener('change', () => this.update()));
      this.cta.addEventListener('click', () => this.addSet(this.cta));
      this.stickyBtn.addEventListener('click', () => {
        if (this.picks().length === 3) return this.addSet(this.stickyBtn);
        const empty = this.selects.find((s) => !s.value) || this.selects[0];
        empty.scrollIntoView({ behavior: 'smooth', block: 'center' });
        empty.focus({ preventScroll: true });
      });

      // Mobile sticky bar: only while the set's own button is off screen (CSS hides it on desktop)
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          this.sticky.hidden = entries[0].isIntersecting;
        }).observe(this.cta);
      }
      this.update();
    }

    picks() {
      return this.selects.map((s) => s.value).filter(Boolean);
    }

    update() {
      const values = this.selects.map((s) => s.value);
      this.selects.forEach((s, i) => {
        // Sold-out oils stay disabled; doubles are capped at the oil's stock
        Array.from(s.options).forEach((opt) => {
          if (!opt.value) return;
          const oil = this.oils[opt.value];
          const others = values.filter((v, j) => j !== i && v === opt.value).length;
          opt.disabled = !oil || !oil.available || others >= oil.max;
        });
        const row = s.closest('[data-ml-row]');
        const img = row.querySelector('img');
        const oil = this.oils[s.value];
        row.classList.toggle('is-filled', !!oil);
        if (oil) img.src = oil.img;
        img.hidden = !oil;
      });

      const n = this.picks().length;
      const left = 3 - n;
      const full = n === 3;
      this.cta.disabled = !full;
      this.cta.textContent = full
        ? this.dataset.fullLabel
        : left === 3 ? 'Choose 3 oils to add the set'
        : left === 1 ? 'Choose 1 more oil' : 'Choose ' + left + ' more oils';
      this.stickyBtn.textContent = full ? 'Add set to cart' : left === 1 ? 'Pick 1 more oil' : 'Pick ' + left + ' more oils';
      this.stickyBtn.classList.toggle('is-ready', full);
      this.querySelector('[data-ml-sticky-note]').textContent = full ? 'Diffuser + 3 oils' : n + '/3 oils chosen';
      this.querySelector('[data-ml-sticky-price]').textContent = full ? this.dataset.setPrice : this.dataset.soloPrice;
    }

    addSet(button) {
      const picks = this.picks();
      if (picks.length !== 3) return;
      const qty = {};
      picks.forEach((id) => { qty[id] = (qty[id] || 0) + 1; });
      const items = [{ id: this.dataset.diffuser, quantity: 1 }];
      Object.keys(qty).forEach((id) => items.push({ id: id, quantity: qty[id] }));
      this.submit(items, button, true);
    }

    addSolo(button) {
      this.submit([{ id: this.dataset.diffuser, quantity: 1 }], button, false);
    }

    submit(items, button, bundled) {
      this.form.innerHTML = '';
      const add = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        this.form.appendChild(input);
      };
      items.forEach((item, i) => {
        add('items[' + i + '][id]', item.id);
        add('items[' + i + '][quantity]', item.quantity);
        if (bundled) add('items[' + i + '][properties][_bundle]', this.dataset.bundle);
      });

      this.querySelectorAll('[data-form-error]').forEach((el) => {
        el.classList.add('hidden');
        el.textContent = '';
      });
      button.setAttribute('disabled', true);

      // Reuse the theme's add-to-cart flow so the drawer, count and free-delivery bar refresh
      if (typeof addItemtoCart === 'function') {
        const drawer = document.querySelector('#ajax-cart-drawer[data-side-drawer]');
        addItemtoCart(this.form, this, button, drawer);
        if (bundled) setTimeout(() => this.update(), 1500);
        return;
      }
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.form),
      }).then(() => { window.location.href = '/cart'; });
    }
  }
  customElements.define('ml-oil-set', MlOilSet);
}
